import { render, staticRenderFns } from "./AddResponsibilityDialog.vue?vue&type=template&id=0c16a460"
import script from "./AddResponsibilityDialog.vue?vue&type=script&lang=js"
export * from "./AddResponsibilityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports